import PropTypes from "prop-types";

function MslMobile({ app, config }) {
  return <></>
}

MslMobile.defaultProps = {
	app: null,
	config: {},
};

MslMobile.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default MslMobile;
